import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import OneDriveProScope from 'owa-service/lib/contract/OneDriveProScope';
import OneDriveConsumerScope from 'owa-service/lib/contract/OneDriveConsumerScope';

export function isOneDriveProScope(scope: AttachmentDataProviderScope): scope is OneDriveProScope {
    return scope.__type === 'OneDriveProScope:#Exchange';
}

export function isOneDriveConsumerScope(
    scope: AttachmentDataProviderScope
): scope is OneDriveConsumerScope {
    return scope.__type === 'OneDriveConsumerScope:#Exchange';
}
